module.exports = __webpack_public_path__ + "static/wpack/extracted/news-bostonglobed8105ed6de686fcb59c09bd62382535c.png";